/**
 * Убирает точки в отображении инициалов пользователя (https://jira.interfax.ru/browse/PUB-2712),
 * оставляя при этом точки в отображении даты
 */
export function formatDescription(string: string): string {
  return string && string.replaceAll
    ? string.replaceAll(/\.(?!\d+)/g, '')
    : string
}
